import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white rounded-xl border border-[#d8d8e2]" }
const _hoisted_2 = { class: "flex flex-col md:flex-row md:items-center md:justify-between gap-3 px-6 py-4 bg-[#f8f8fa] border-b border-[#d8d8e2] rounded-t-xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold text-[#16161d] text-left" }, "Convite completo", -1)
const _hoisted_4 = { class: "flex items-center gap-2 flex-wrap" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-1 rounded px-2 py-1 border text-sm whitespace-nowrap bg-[#fef9e7] border-[#f1c21b] text-[#16161d]",
  "data-testid": "package-awaiting-review-badge"
}
const _hoisted_6 = {
  class: "text-xs font-semibold text-[#16161d] bg-white border border-[#d8d8e2] rounded px-2 py-1 whitespace-nowrap",
  "data-testid": "package-stations-count-chip"
}
const _hoisted_7 = { class: "flex flex-col gap-5 px-6 py-5" }
const _hoisted_8 = {
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border border-[#e8e8ed] rounded-lg divide-y sm:divide-y-0 divide-[#e8e8ed] sm:divide-x",
  "data-testid": "package-info-row"
}
const _hoisted_9 = { class: "text-xs text-left text-[#7f7f8e]" }
const _hoisted_10 = { class: "text-sm font-semibold text-left text-[#16161d] truncate" }

import { computed } from 'vue'
import { format, parseISO } from 'date-fns'
import { PackageResponse } from '@/Network/Types/Responses/HandoverInviteResponses'
import { PackageStatus } from '@/Network/Types/Requests/HandoverInviteRequests'
import { formatCurrency } from '@/utils/formatters'
import StationsTable from './StationsTable.vue'
import HandoverExpirationBadge from './HandoverExpirationBadge.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PackageDetailCard',
  props: {
    packageData: {}
  },
  setup(__props: any) {

const props = __props;



const isAwaitingReview = computed(() => props.packageData.status === PackageStatus.IN_ADMIN_QUEUE)

// Um convite pode agrupar plantões de unidades diferentes — exibimos a primeira
// e sinalizamos as demais com um contador, como na listagem de histórico.
const healthUnitNames = computed(() => {
  const names = props.packageData.stations
    .map((station) => station.healthUnit?.name)
    .filter((name): name is string => !!name)
  return [...new Set(names)]
})

const healthUnitName = computed(() => {
  const [first, ...rest] = healthUnitNames.value
  if (!first) return '-'
  return rest.length > 0 ? `${first} +${rest.length}` : first
})

const formattedCreatedAt = computed(() => {
  try {
    return format(parseISO(props.packageData.createdAt), "dd/MM/yyyy 'às' HH:mm")
  } catch {
    return props.packageData.createdAt
  }
})

const formattedTotalValue = computed(() => {
  const total = props.packageData.stations.reduce((sum, s) => sum + (s.value ?? 0), 0)
  return formatCurrency(total)
})

const infoItems = computed(() => [
  { label: 'Unidade', value: healthUnitName.value },
  { label: 'Escala', value: props.packageData.schedule.name },
  { label: 'Criado em', value: formattedCreatedAt.value },
  { label: 'Valor estimado total', value: formattedTotalValue.value }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (isAwaitingReview.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Aguardando avaliação "))
          : _createCommentVNode("", true),
        _createVNode(HandoverExpirationBadge, {
          "expires-at": _ctx.packageData.expiresAt,
          "show-date": ""
        }, null, 8, ["expires-at"]),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.packageData.stations.length) + " Plantões no convite ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoItems.value, (info) => {
          return (_openBlock(), _createElementBlock("div", {
            key: info.label,
            class: "flex flex-col gap-1 px-4 py-3 min-w-0"
          }, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(info.label), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(info.value), 1)
          ]))
        }), 128))
      ]),
      _createVNode(StationsTable, {
        stations: _ctx.packageData.stations,
        recurrence: _ctx.packageData.recurrence
      }, null, 8, ["stations", "recurrence"])
    ])
  ]))
}
}

})